import React from "react";
import { Conversation } from "..";
import { useParams } from "react-router-dom";
import avatar from "assets/img/avatars/avatarSimmmple.png";
import { Agent } from "types";
import { Image } from "components/Image";

interface ConversationItemProps {
  conversation: Conversation;
  agent?: Agent;
  convoId: string;
  onClick: () => void;
}

const ConversationItem: React.FC<ConversationItemProps> = ({
  conversation,
  convoId,
  agent,
  onClick,
}) => {
  const { "*": id } = useParams<{ "*": string }>();
  const pathSegments = id?.split("/") || [];
  const isActive = pathSegments[1] === convoId;

  return (
    <div
      className={`flex cursor-pointer items-center gap-3 rounded-lg p-3 transition-all duration-200 hover:bg-gray-50/80 dark:hover:bg-navy-700 ${
        isActive
          ? "bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm   dark:bg-gradient-to-r dark:from-navy-700 dark:to-navy-900 dark:shadow-lg"
          : ""
      }`}
      onClick={onClick}
    >
      <Image
        src={agent?.icon_uri}
        fallbackSrc={avatar}
        alt={agent?.name || "Agent"}
        className="border-transparent h-8 w-8 rounded-full border-2 object-cover transition-transform hover:scale-105"
      />
      <span className="truncate text-sm font-medium text-[#6c6f93] transition-colors hover:text-[#4a4d6a] dark:text-gray-200 dark:hover:text-white">
        {conversation.name || "New Conversation"}
      </span>
    </div>
  );
};

export default ConversationItem;
